import { defineStore } from 'pinia';
import { ref } from 'vue';
import axios from 'axios';

const baseUrl = process.env.VUE_APP_BASE_URL;

export const usePortfoliosStore = defineStore('portfolios', () => {
  const portfolios = ref([]);
  const isLoading = ref(false);
  const error = ref(null);

  const fetchPortfolios = async () => {
    isLoading.value = true;
    error.value = null;

    try {
      const token = localStorage.getItem('token'); 
      const response = await axios.get(`${baseUrl}`+'/api/portfolios/?populate=*&sort[0]=id:asc', {
        headers: {
          Authorization: `Bearer ${token}`, 
        },
      });      
      // Mapping the response data to the desired format
      portfolios.value = response.data.data.map(item => ({
        id: item.id,
        Name: item.Name,
      }));

    } catch (err) {
      error.value = err.response?.data?.message || 'Failed to fetch data'; // Use the error message from the response
    } finally {
      isLoading.value = false;
    }
  };

  return { portfolios, isLoading, error, fetchPortfolios };
});
